import Config from 'config/MainConfig';
import axios from 'axios';

export const SendOtpCall = (mobile) => {
    return new Promise((resolve, reject) => {
        axios.post(Config['URL'] + '/send_otp', {'mobile': mobile})
            .then(function (res) {
                if (res.data.result === 'success') {
                    localStorage.setItem('mobile', mobile);
                    resolve(res);
                }
                if (res.data.result === 'error') {
                    reject(res.data.message);
                }
            })
    })
};

export const ResendOtpCall = () => {
    return new Promise((resolve, reject) => {
        axios.get(Config['URL'] + '/resend_otp?mobile=' + localStorage.getItem("mobile"))
            .then(function (res) {
                if (res.data.result === 'success') {
                    resolve(res);
                }
                if (res.data.result === 'error') {
                    reject(res.data.message);
                }
            })
    })
};

export const VerifyOtpCall = (mobile, otp) => {
    return new Promise((resolve, reject) => {
        axios.post(Config['URL'] + '/verify_mobile', {
            'mobile': mobile,
            'code': otp
        }).then((res) => {
            if (res.data.result === 'success') {
                localStorage.setItem('mobile', mobile);
                localStorage.setItem('accessToken', res.data.data.access_token);
                localStorage.setItem('profile', JSON.stringify(res.data.data.profile));
                resolve(res);
            }
            if (res.data.result === 'error') {
                reject(res.data.message);
            }
        })
    })
};


// WEBPACK FOOTER //
// ./src/api/LoginApi.jsx